// MobileNavBuyer.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Divider, Button, Typography, Stack } from '@mui/material';
import { ArrowSquareUpRight as ArrowSquareUpRightIcon } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { navItems } from './navItemsBuyer';
const notedinLogo = new URL('../../../../assets/images/notedin.png', import.meta.url).href;


export const SideNav = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavigation = (event: React.MouseEvent, href: string) => {
    event.preventDefault();
    navigate(href);
  };

  return (
    <Box
      sx={{
        width: 250,
        position: 'fixed',
        top: '88px',
        left: 0,
        bottom: '100px', // or the exact height of your bottom nav
        bgcolor: 'background.paper',
        boxShadow: 3,
        display: 'flex',
        flexDirection: 'column',
        pb: 2,
        zIndex: 1200,
      }}
    >
      <Typography variant="h6" sx={{ p: 4 }}>
        {t('parcelManagement')}
      </Typography>
      <Divider />

      <Box sx={{ flex: '1 1 auto', p: 2 }}>
        {navItems.map((item) => {
          if (item.isBottom) return null;

          return (
            <Box
              key={item.key}
              component="div"
              role="button"
              onClick={(event) => handleNavigation(event, item.href)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '8px',
                borderRadius: 1,
                color: 'text.secondary',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: 'action.hover',
                },
              }}
              aria-label={t(item.title)}
            >
              <Box sx={{ mr: 2 }}>
                <item.icon />
              </Box>
              <Typography variant="body1">{t(item.title)}</Typography>
            </Box>
          );
        })}
      </Box>

      <Divider sx={{ mt: 'auto', borderColor: 'divider' }} />

      <Stack spacing={2} sx={{ p: 2, pb: 8 }}>
        <div>
          <Typography color="text.primary" variant="subtitle2">
            {t('needMoreDeliveries')}
          </Typography>
          <Typography color="text.secondary" variant="body2">
            {t('getProVersion')}
          </Typography>
        </div>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
<Box
  component="img"
  alt="NotedIn Logo"
  src={notedinLogo}
  sx={{ height: 'auto', width: '90px' }}
/>


        </Box>
        <Button
          component="a"
          endIcon={<ArrowSquareUpRightIcon fontSize="inherit" />}
          fullWidth
          href="mailto:mlubo@notedin.com?subject=Inquiry%20about%20Pro%20Version"
          target="_blank"
          variant="contained"
        >
          {t('proVersion')}
        </Button>
      </Stack>
    </Box>
  );
};
